import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import swal from "sweetalert";

export default function ImagePage() {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openImage, setOpenImage] = React.useState(false);
  const [formData, setFormData] = React.useState({
    name: ``,
    slug: ``,
    parentId: 0,
  });
  const [errors, setErrors] = React.useState({});
  const [image, setImage] = React.useState(null);
  const [preview, setPreview] = React.useState(null);
  const [selectedImage, setSelectedImage] = React.useState({ isHome: false });
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [checked, setChecked] = React.useState(false);
  const [isBanner, setIsBanner] = React.useState(false);

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  React.useEffect(() => {
    getData();
  }, [currentPage]);

  const getData = () => {
    axios
      .get(`/api/v1/images`, {
        params: {
          page: currentPage,
          limit: 28,
        },
      })
      .then((res) => {
        setRows(res.data.images);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => console.log(err));
  };

  const handleOpen = (data) => {
    setOpen(true);
    if (data) {
      setFormData(data);
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setImage(null);
    setPreview(null);
    setChecked(false);
    setIsBanner(false);
    if (isReload) {
      getData();
    }
  };

  const handleOpenImage = (item) => {
    setOpenImage(true);
    axios
      .get(`/api/v1/images/` + item.id)
      .then((res) => {
        setSelectedImage(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleCloseImage = () => {
    setOpenImage(!openImage);
    setSelectedImage({ isHome: false, isBanner: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const sendData = {
      path: image,
      isHome: checked,
      isBanner: isBanner,
    };
    axios
      .post(`/api/v1/images`, sendData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        toast("Thêm hình ảnh thành công!", {
          type: "success",
          autoClose: 1000,
        });
        handleClose(true);
      })
      .catch((err) => {
        console.log(err);
        toast("Có lỗi xảy ra!", {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  const handleUpdate = async (e, id) => {
    e.preventDefault();
    axios
      .put(`/api/v1/images/` + id, {
        isHome: selectedImage.isHome,
        isBanner: selectedImage.isBanner,
      })
      .then((res) => {
        toast("Cập nhật hình ảnh thành công!", {
          type: "success",
          autoClose: 1000,
        });
        handleCloseImage();
        getData();
      })
      .catch((err) => {
        console.log(err);
        toast("Có lỗi xảy ra!", {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  const handleDelete = (id) => {
    swal({
      title: `Bạn muốn xóa hình ảnh này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/images/${id}`)
          .then((res) => {
            toast("Xoá hình ảnh thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
            handleCloseImage();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý hình ảnh
      </Typography>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="info"
          sx={{ width: 100 }}
          onClick={handleOpen}
        >
          Thêm
        </Button>
      </Box>
      <Paper
        sx={{
          height: 600,
          width: "100%",
          display: "grid",
          gap: 1,
          p: 2,
          gridTemplateColumns: {
            xl: "repeat(7, 1fr)",
            "@media (max-width: 1536px)": {
              gridTemplateColumns: "repeat(5, 1fr)",
            },
            "@media (max-width: 1024px)": {
              gridTemplateColumns: "repeat(3, 1fr)",
            },
          },
          gridAutoRows: 130,
          overflowY: "auto",
        }}
      >
        {rows.map((item, idx) => (
          <Box
            component="img"
            key={idx}
            onClick={(e) => handleOpenImage(item)}
            sx={{
              width: 220,
              height: 130,
              objectFit: "cover",
              borderRadius: "8px",
              mb: 2,
              cursor: "pointer",
            }}
            alt={item.path}
            src={item.path}
          />
        ))}
      </Paper>
      <div className="pagination">
        <button
          className={`page-button ${currentPage == 1 ? "active" : ""}`}
          id="prev-btn"
          disabled={currentPage == 1}
          onClick={() => goToPage(currentPage - 1)}
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        <span className="page-numbers">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={`page-number ${
                index + 1 === currentPage ? "active" : ""
              }`}
              onClick={() => goToPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </span>
        <button
          className={`page-button ${currentPage == totalPages ? "active" : ""}`}
          id="next-btn"
          disabled={currentPage == totalPages}
          onClick={() => goToPage(currentPage + 1)}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>

      {/* Add Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 600,
              p: 5,
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              Thêm hình ảnh
            </Typography>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 5 }}
            >
              <Button variant="outlined" component="label">
                Tải ảnh lên
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </Button>
              <Box sx={{ color: "red", fontSize: 14 }}>
                (*) Nếu là hình ảnh tại nơi giao thì khuyến kích chọn hình ảnh
                có kích thước 500 x 600
              </Box>
              {image && (
                <TextField
                  label="Tên tệp"
                  value={image.name}
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              )}
              {preview && (
                <Box sx={{ marginTop: 2 }}>
                  <Typography variant="body1">Xem trước:</Typography>
                  <Box
                    component="img"
                    sx={{
                      width: 200,
                      height: 300,
                      objectFit: "cover",
                      borderRadius: "8px",
                      mb: 2,
                    }}
                    alt={preview}
                    src={preview}
                  />
                </Box>
              )}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                label="Hình ảnh tại nơi giao"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isBanner}
                    onChange={(e) => setIsBanner(e.target.checked)}
                  />
                }
                label="Hiển thị banner"
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button variant="contained" color="info" onClick={handleSubmit}>
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>

      {/* Image info Modal */}
      <Modal open={openImage} onClose={handleCloseImage}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            width: "600px",
            height: "95vh",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Box sx={{ textAlign: "end" }}>
            <Button variant="text" onClick={handleCloseImage}>
              <i className="bi bi-x-lg" style={{ fontSize: 24 }}></i>
            </Button>
          </Box>
          {selectedImage && (
            <img
              src={selectedImage.path}
              alt="selected"
              style={{
                width: "100%",
                height: "80%",
                borderRadius: 4,
                objectFit: "cover",
              }}
            />
          )}
          <Box
            sx={{
              pt: 3,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedImage.isHome}
                  onChange={(e) =>
                    setSelectedImage({
                      ...selectedImage,
                      isHome: e.target.checked,
                    })
                  }
                />
              }
              label="Hình ảnh tại nơi giao"
            />
            <Button
              variant="contained"
              onClick={(e) => handleUpdate(e, selectedImage.id)}
            >
              Lưu thay đổi
            </Button>
          </Box>
          <Box
            sx={{
              pt: 3,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedImage.isBanner}
                  onChange={(e) =>
                    setSelectedImage({
                      ...selectedImage,
                      isBanner: e.target.checked,
                    })
                  }
                />
              }
              label="Hiển thị banner"
            />
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDelete(selectedImage.id)}
            >
              Xoá
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
